<template>
    <BreadCrumb PageTitle="État des usagers" />
    <EtatUsagers />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EtatUsagers from "../../components/Etats/EtatUsagers.vue";
  
    export default defineComponent({
      name: "EtatUsagersPage",
      components: {
        BreadCrumb,
        EtatUsagers,
      },
    });
  </script>
